function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Menu/Iconen/Overzicht",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "BE_building",
  fill: "#425CD4",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0.0413793103 L0,30.1172414 L29.9931034,30.1172414 L29.9931034,0.0413793103 L0,0.0413793103 Z M17.0689655,29.5448276 L13.4275862,29.5448276 L13.4275862,26.3172414 L17.0689655,26.3172414 L17.0689655,29.5448276 Z M23.0758621,29.5448276 L17.6206897,29.5448276 L17.6206897,29.4965517 L17.6068966,25.7448276 L12.8827586,25.7448276 L12.8896552,29.5448276 L7.15862069,29.5448276 L7.15862069,11.5724138 L23.0758621,11.5724138 L23.0758621,29.5448276 L23.0758621,29.5448276 Z M23.0758621,11.0275862 L19.7103448,11.0275862 L19.7103448,9.45517241 L19.1655172,9.45517241 L19.1655172,11.0275862 L15.5241379,11.0275862 L15.5241379,9.45517241 L14.9793103,9.45517241 L14.9793103,11.0275862 L11.337931,11.0275862 L11.337931,9.45517241 L10.7931034,9.45517241 L10.7931034,11.0275862 L7.15172414,11.0275862 L7.15172414,6.02758621 L23.0689655,6.02758621 L23.0689655,11.0275862 L23.0758621,11.0275862 Z M29.4137931,29.5448276 L23.6137931,29.5448276 L23.6137931,5.48275862 L6.6137931,5.48275862 L6.6137931,29.537931 L0.572413793,29.537931 L0.572413793,0.613793103 L29.4137931,0.613793103 L29.4137931,29.5448276 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 10.8,
  y: 20.6,
  width: 1,
  height: 2.3862069
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 10.8,
  y: 15.0275862,
  width: 1,
  height: 2.3862069
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 14.9793103,
  y: 20.6,
  width: 1,
  height: 2.3862069
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 14.9793103,
  y: 15.0275862,
  width: 1,
  height: 2.3862069
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 19.1655172,
  y: 20.6,
  width: 1,
  height: 2.3862069
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 19.1655172,
  y: 15.0275862,
  width: 1,
  height: 2.3862069
})));
function SvgOverviewBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Menu/Iconen/Overzicht") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewBlue);
export default __webpack_public_path__ + "static/media/Overview_blue.c4d4cf58c3d58df3e62b8fbb7722979b.svg";
export { ForwardRef as ReactComponent };